import React, { useState, useEffect } from 'react';
import './Blog.css';

const Blog = ({ onBack }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  // Load blogs from localStorage on mount
  useEffect(() => {
    try {
      const savedBlogs = localStorage.getItem('stocks4u_blogs');
      if (savedBlogs) {
        const parsed = JSON.parse(savedBlogs);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setBlogs(parsed);
        } else {
          setDefaultBlog();
        }
      } else {
        setDefaultBlog();
      }
    } catch (error) {
      console.error('Error loading blogs:', error);
      setDefaultBlog();
    }
    setLoading(false);
  }, []);

  const setDefaultBlog = () => {
    const defaultBlogs = [
      {
        id: 1,
        title: "Market Kya Keh Raha Hai?",
        excerpt: "Redefining the user acquisition and redesigned the onboarding experience, all within 3 working weeks.",
        content: "Full content here...",
        date: new Date().toISOString(),
        category: "Info",
        image: null,
        isFeatured: true
      }
    ];
    setBlogs(defaultBlogs);
    localStorage.setItem('stocks4u_blogs', JSON.stringify(defaultBlogs));
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      const subscribers = JSON.parse(localStorage.getItem('stocks4u_subscribers') || '[]');
      if (!subscribers.includes(email)) {
        subscribers.push(email);
        localStorage.setItem('stocks4u_subscribers', JSON.stringify(subscribers));
        setSubscribeStatus('Subscribed successfully!');
        setEmail('');
      } else {
        setSubscribeStatus('You are already subscribed!');
      }
      setTimeout(() => setSubscribeStatus(''), 3000);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  };

  const featuredBlog = blogs.find(blog => blog.isFeatured) || blogs[0];
  const recentBlogs = blogs.filter(blog => blog.id !== featuredBlog?.id).slice(0, 4);

  if (loading) {
    return (
      <div className="blog-page">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'white' }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <header className="blog-header">
        <div className="blog-header-container">
          {onBack && (
            <button className="blog-back-btn" onClick={onBack}>
              ← Back
            </button>
          )}
          <h1>Stocks4U Blog</h1>
        </div>
      </header>

      <main className="blog-main">
        {/* Featured Blog */}
        {featuredBlog ? (
          <section className="featured-blog">
            <div className="featured-blog-card">
              {featuredBlog.image && (
                <div className="featured-blog-image">
                  <img src={featuredBlog.image} alt={featuredBlog.title} />
                </div>
              )}
              <div className="featured-blog-content">
                <div className="blog-meta">
                  {featuredBlog.category && (
                    <span className="blog-category">{featuredBlog.category}</span>
                  )}
                </div>
                <h2 className="featured-blog-title">{featuredBlog.title}</h2>
                <p className="featured-blog-excerpt">{featuredBlog.excerpt}</p>
                <span className="blog-date">{formatDate(featuredBlog.date)}</span>
              </div>
            </div>
          </section>
        ) : (
          <section className="featured-blog">
            <div className="featured-blog-card" style={{ textAlign: 'center', padding: '3rem' }}>
              <p style={{ color: 'rgba(255,255,255,0.7)' }}>No blogs available yet.</p>
              <button 
                onClick={setDefaultBlog}
                style={{
                  marginTop: '1rem',
                  padding: '0.75rem 1.5rem',
                  background: 'linear-gradient(135deg, #8B5CF6, #6D28D9)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
              >
                Load Sample Blog
              </button>
            </div>
          </section>
        )}

        {/* Recent Blogs */}
        <section className="recent-blogs">
          <h3 className="section-title">Recent Blogs</h3>
          <div className="blogs-list">
            {recentBlogs.length > 0 ? (
              recentBlogs.map(blog => (
                <article key={blog.id} className="blog-card">
                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="blog-card-label">BLOG</span>
                      <span className="blog-card-date">{formatDate(blog.date)}</span>
                    </div>
                    <h4 className="blog-card-title">{blog.title}</h4>
                    <p className="blog-card-excerpt">{blog.excerpt}</p>
                  </div>
                  {blog.image && (
                    <div className="blog-card-image">
                      <img src={blog.image} alt={blog.title} />
                    </div>
                  )}
                </article>
              ))
            ) : (
              <p className="no-blogs">No recent blogs available.</p>
            )}
          </div>
        </section>

        {/* Subscribe Section */}
        <section className="subscribe-section">
          <h3 className="subscribe-title">Subscribe To My Blogs</h3>
          <form className="subscribe-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="subscribe-input"
            />
            <button type="submit" className="subscribe-btn">
              Join Now
            </button>
          </form>
          {subscribeStatus && <p className="subscribe-status">{subscribeStatus}</p>}
        </section>
      </main>
    </div>
  );
};

export default Blog;
